import MatomoTracker from '../utils/MatomoTracker.js';

let matomoClickHandler = null;

/**
 * Initialise le tracking Matomo pour tous les éléments avec data-matomo-track
 */
const initMatomoTracking = () => {
    if (matomoClickHandler) {
        document.removeEventListener('click', matomoClickHandler);
        matomoClickHandler = null;
    }

    // Créer le nouveau handler
    matomoClickHandler = (e) => {
        const element = e.target.closest('[data-matomo-track]');
        
        if (!element) return;

        // Extraire les données depuis les attributs
        const trackingData = MatomoTracker.extractDataFromElement(element);
        
        if (trackingData) {
            // Déterminer le nom de l'événement :
            // - Pour les éléments de navigation, utiliser le component_name
            // - Pour les autres éléments, utiliser "CTA Click" ou "Form Submit"
            let eventName = 'CTA Click';
            
            // Si c'est un élément de type Page (ex. navigation / menu), utiliser "navigation" comme catégorie Matomo
            if (trackingData.component_name === 'page') {
                eventName = 'navigation';
            }
            
            // Pour les liens, tracker avant la navigation
            if (element.tagName === 'A' || element.tagName === 'a') {
                // Si c'est un lien externe ou qui change de page, tracker immédiatement
                const href = element.getAttribute('href');
                if (href && (href.startsWith('http') || href.startsWith('/') || href.startsWith('#'))) {
                    MatomoTracker.trackEvent(trackingData, eventName, element);
                }
            } else {
                // Pour les boutons et autres éléments (comme les onglets), tracker directement
                // Ne pas vérifier href car les boutons n'ont pas d'attribut href
                MatomoTracker.trackEvent(trackingData, eventName, element);
            }
        } else {
            // Debug : vérifier pourquoi les données ne sont pas extraites
            if (MatomoTracker.debugMode) {
                console.warn('MatomoTracker: Données non extraites pour l\'élément', element);
                console.log('Attributs data-matomo-*:', {
                    'data-matomo-track': element.getAttribute('data-matomo-track'),
                    'data-matomo-cta-type': element.getAttribute('data-matomo-cta-type'),
                    'data-matomo-component': element.getAttribute('data-matomo-component'),
                    'data-matomo-role': element.getAttribute('data-matomo-role'),
                    'data-matomo-page-type': element.getAttribute('data-matomo-page-type'),
                    'data-matomo-offre': element.getAttribute('data-matomo-offre')
                });
            }
        }
    };

    // Ajouter le nouveau listener
    document.addEventListener('click', matomoClickHandler);

    // Gestion spéciale pour les formulaires Gravity Forms
    if (typeof jQuery !== 'undefined') {
        jQuery(document).off('gform_confirmation_loaded.matomoTracking');
        jQuery(document).on('gform_confirmation_loaded.matomoTracking', function (event, formId) {
            // Trouver le formulaire soumis
            const formContainer = document.querySelector(`.js-gravity-form[data-id="${formId}"]`);
            if (formContainer && formContainer.hasAttribute('data-matomo-track')) {
                const trackingData = MatomoTracker.extractDataFromElement(formContainer);
                if (trackingData) {
                    MatomoTracker.trackEvent(trackingData, 'Form Submit', formContainer);
                }
            }
        });
    }
};

export { initMatomoTracking };
